import { afterNextRender, Component, ElementRef, inject, Injector, signal, viewChild } from '@angular/core';

import { SasButtonComponent, SasSignUserComponent } from '@components';
import { Language } from '@interfaces';
import { AppService } from '@services';
import { SasLanguageSelectorComponent } from '../sas-language-selector/sas-language-selector.component';
import { SasMenuService } from '../sas-menu/sas-menu.service';
import { HeaderSearchService } from './header-search.service';

const LANGUAGES_OPTIONS_KEY = 'LANGUAGES_OPTIONS';

@Component({
    selector: 'sas-header',
    standalone: true,
    imports: [SasLanguageSelectorComponent, SasButtonComponent, SasSignUserComponent],
    templateUrl: './sas-header.component.html',
    styleUrls: ['./sas-header.component.scss']
})
export class SasHeaderComponent {
    private readonly appService = inject(AppService);
    private readonly injector = inject(Injector);
    private readonly headerSearchService = inject(HeaderSearchService);
    readonly menuService = inject(SasMenuService);
    readonly languages: Language[] = this.appService.getConfiguration(LANGUAGES_OPTIONS_KEY) ?? [];

    readonly searchOpen = signal(false);
    readonly searchQuery = this.headerSearchService.searchQuery;
    private readonly mobileSearchInput = viewChild<ElementRef<HTMLInputElement>>('mobileSearchInput');

    get searchEnabled(): boolean {
        return this.headerSearchService.isAvailable();
    }

    toggleSearch() {
        this.searchOpen.update(v => !v);
        if (this.searchOpen()) {
            afterNextRender(() => this.mobileSearchInput()?.nativeElement.focus(), { injector: this.injector });
        }
    }

    onSearch(): void {
        this.headerSearchService.performSearch(this.searchQuery());
    }

    clearSearch(): void {
        this.headerSearchService.clearQuery();
    }
}
